function equalizeBenefitsHeights() {
  const textWithFeatureCards = document.querySelectorAll('.text-with-feature-cards');
  textWithFeatureCards.forEach((textWithFeatureCard) => {
    const cards = Array.from(textWithFeatureCard.querySelectorAll('.text-with-feature-cards__item'));
    if (cards.length === 0) return;

    cards.forEach((card) => {
      card.querySelectorAll('.text-with-feature-cards__text-height').forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.style.height = '';
      });
    });

    requestAnimationFrame(() => {
      const benefitsMatrix = [];

      cards.forEach((card, cardIndex) => {
        const benefitEls = Array.from(card.querySelectorAll('.text-with-feature-cards__text-height'));

        benefitEls.forEach((el, i) => {
          if (!benefitsMatrix[i]) benefitsMatrix[i] = [];
          benefitsMatrix[i][cardIndex] = el;
        });
      });

      // eslint-disable-next-line max-len
      const heights = benefitsMatrix.map((row) => Math.max(...row.map((el) => el?.offsetHeight || 0)));

      benefitsMatrix.forEach((row, rowIndex) => {
        row.forEach((el) => {
          // eslint-disable-next-line no-param-reassign
          if (el) el.style.height = `${heights[rowIndex]}px`;
        });
      });
    });
  });
}

window.addEventListener('resize', () => {
  clearTimeout(window.benefitsResizeTimeout);
  window.benefitsResizeTimeout = setTimeout(() => {
    requestAnimationFrame(equalizeBenefitsHeights);
  }, 100);
});

window.addEventListener('load', () => {
  requestAnimationFrame(equalizeBenefitsHeights);
});
